import { makeVar } from '@apollo/client';

interface SendOnboardingNotifDialog {
  open: boolean;
  employeeId: number | null;
  refetchFunc: () => Promise<void>;
}

interface SendRecoveryDialog {
  open: boolean;
  employeeId: number | null;
  employeeWorkSpaceId: number | null;
  refetchFunc: () => Promise<void>;
}

export interface EmployeeInfoDialog {
  open: boolean;
  employeeId: number | null;
  employeeWorkSpaceId: number | null;
  tab: string | null;
  onClose: () => void;
  refetchFunc: () => Promise<void>;
}

interface SendMassiveOnboardingNotificationDialog {
  open: boolean;
}

const sendOnboardingNotifDialogVarDefault: SendOnboardingNotifDialog = {
  open: false,
  employeeId: null,
  refetchFunc: async () => {},
};

const sendRecoveryDialogVarDefault: SendRecoveryDialog = {
  open: false,
  employeeId: null,
  employeeWorkSpaceId: null,
  refetchFunc: async () => {},
};

const employeeInfoDialogVarDefault: EmployeeInfoDialog = {
  open: false,
  employeeId: null,
  employeeWorkSpaceId: null,
  tab: null,
  onClose: () => {},
  refetchFunc: async () => {},
};

const sendMassiveOnboardingNotificationDialogVarDefault: SendMassiveOnboardingNotificationDialog =
  {
    open: false,
  };

export const sendOnboardingNotifDialogVar = makeVar(
  sendOnboardingNotifDialogVarDefault,
);
export const sendRecoveryDialogVar = makeVar(sendRecoveryDialogVarDefault);
export const employeeInfoDialogVar = makeVar(employeeInfoDialogVarDefault);
export const sendMassiveOnboardingNotificationDialogVar = makeVar(
  sendMassiveOnboardingNotificationDialogVarDefault,
);

export const resetSendOnboardingNotifDialogVar = (): void => {
  sendOnboardingNotifDialogVar(sendOnboardingNotifDialogVarDefault);
};

export const resetSendRecoveryDialogVar = (): void => {
  sendRecoveryDialogVar(sendRecoveryDialogVarDefault);
};

export const resetEmployeeInfoDialogVar = (): void => {
  employeeInfoDialogVar(employeeInfoDialogVarDefault);
};

export const setEmployeeInfoDialogVar = (
  input: Partial<EmployeeInfoDialog>,
): void => {
  employeeInfoDialogVar({
    ...employeeInfoDialogVar(),
    ...input,
  });
};

export const resetSendMassiveOnboardingNotificationDialogVar = (): void => {
  sendMassiveOnboardingNotificationDialogVar(
    sendMassiveOnboardingNotificationDialogVarDefault,
  );
};
